import React from "react";
import { useNavigate } from "react-router-dom";

function CheckEmail (){
    const navigate = useNavigate();

    return(
        <div>
              <img src="/peeqlogo.svg" alt="Peeq Logo" className="mx-auto pt-10 cursor-pointer" onClick={()=>navigate('/accounts/business')} />
              
              <div className="flex justify-center rounded-full bg-[#FFF7E5] m-auto w-[200px] h-[200px] mt-8">
              <img src="/Email.svg" alt="Peeq Logo" className="p-[60px]" />
              </div>
              <div className="emailcontent"> 
              
               <div className="emailinputs m-auto">
               <div className="title">Check your Email</div>
                 <p className="text">We’ve sent a link to your email. 
Please click the link to confirm email change.
(If you don’t see a message, check your junk/spam)</p>   
               </div> 
            </div>
        </div>
    )
}

export default CheckEmail;